import React from "react";

export const Group = ({ children, additionalClasses }) => {
  // Combine the core classNames with any additional classes passed via props
  const classNames = `group group-separators editorShadow ${additionalClasses || ""}`;
  return <div className={classNames}>{children}</div>;
};

export default Group;